// Auth-related localStorage keys, extracted to a leaf module so both
// `useAuthStore` (which reads them at module-load time to compute initial
// state) and `authService` (which reads/writes them during the auth flow)
// can import them without creating a circular dependency.
//
// Naming convention in core: bare `hp_` prefix, no app slug.
//
// The three sibling starter apps (admin/www/chef) carry their own copies of
// these constants with a per-app slug (`hp_a_*`, `hp_w_*`, `hp_c_*`) so each
// origin's localStorage is self-descriptive in DevTools. Core stays bare
// because it predates the multi-app split and existing live keys here
// (`hp-location`, `hp_device`, etc.) follow the no-slug pattern.
//
// The JWT/EMAIL/SECRET trio is only written in localStorage session mode
// (`VITE_SESSION_MODE=localStorage`). In cookie mode (the default for
// staging/prod) the JWT lives in an HttpOnly cookie and these keys are
// never set — kept here so the localStorage code path still compiles + works
// for dev configs that opt out of cookie mode.

export const JWT_STORAGE_KEY = 'hp_a_jwt';
export const EMAIL_STORAGE_KEY = 'hp_a_email';
export const SECRET_STORAGE_KEY = 'hp_a_secret';

// Holds a JSON blob `{ isRegistered: boolean, isOnboarded: boolean }`.
// Written at the end of every successful whoami, cleared on logout. Used by
// `useAuthStore` to hydrate initial gate state synchronously at boot so the
// three React Router gates (Location/Registration/Onboarding) can paint
// immediately without waiting on the whoami round-trip.
export const GATES_STORAGE_KEY = 'hp_a_gates';
